/**
 * Picks v2 or v1 of the Card edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../../utils/redesignFlag';
import AddEditCard   from './AddEditCard';
import AddEditCardV2 from './AddEditCardV2';

export default function AddEditCardSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AddEditCardV2 : AddEditCard;
  return <Component {...props} />;
}
